import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../redux/store";
import { Link, useNavigate, useParams } from "react-router-dom";
import qs from "qs";
import { Placeholder } from "../components/Placeholder";
import { CommentBox } from "../components/CommentBox";
import {
  fetchLoungeDetails,
  postLoungeCommentEditWdw,
} from "../redux/lounges/slice";
import { selectLounges } from "../redux/lounges/selectors";
import { GET_BASE_URL_IMAGE, dTime } from "../constants/apiEndpoints";
import { useForm } from "react-hook-form";
import midBanner from "../assets/img/mid-banner-img.png";
import { ToggleMenu } from "../components/ToggleMenuDisneyWorld";
import { CommonPostMessage } from "../components/CommonPostMessage";
import stickerImage from "../assets/img/stickers.jpg";
import faceBookImage from "../assets/img/face-s.jpg";
import pinImage from "../assets/img/face-s.jpg";
import { WdwLoungeName } from "../components/WdwLoungeName";
import {
  postThankyou,
  postBookMark,
  postLoungeFlagWdw,
  fetchStickerLounges,
  addSticker,
  removeUserLounge,
  fetchwdwLoungeDetails,
} from "../redux/lounges/slice";
import cardmImage from "../assets/img/card-m-img.png";

import { CommentList } from "../components/WdwCommentList";
import { onSubmitWdw } from "../utils/commentUtils";
import { Helmet } from "react-helmet-async";
import { getMouseWaitUserAvatarUrl } from "../utils/avatar";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { ChatImageWithFallback } from "../components/ChatImageWithFallback";
import { ThankAvatarStrip } from "../components/ThankAvatarStrip";

type FormData = {
  chat_msg: string;
  chat_id: number;
  // chat_type: any;
  chat_reply_msg_advance: any;
};

const WDWLandLoungeDetail = (props: any) => {
  const dispatch = useAppDispatch();
  const { LoungeId, url } = useParams();
  const { itemDetail, stickerItems } = useSelector(selectLounges);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm<FormData>();
  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user_id");
  const [commentData, SetCommentData] = useState<any | []>([]);
  const [thankData, SetThankData] = useState<any | []>([]);
  const [showIcon, SetShowIcon] = useState<any | string>(true);
  const [chatMessage, setChatMessage] = useState();
  const [bookMark, SetBookMark] = useState<any | string>(false);
  const [thankYou, SetThankYou] = useState<any | string>(false);
  const [isDetailLoading, setIsDetailLoading] = useState(true);
  const [detailLoadError, setDetailLoadError] = useState(false);

  const [flagType, setFlagType] = useState<any | string>("C");
  const [flagAction, setFlagAction] = useState<any | string>("move-silent");

  const user_id = localStorage.removeItem("userid");

  const onClickIcon = () => {
    SetShowIcon(!showIcon);
  };
  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsDetailLoading(true);
    setDetailLoadError(false);

    dispatch(fetchwdwLoungeDetails({ LoungeId }))
      .then((res: any) => {
        const detail = res?.payload?.[0];
        if (!detail) {
          setDetailLoadError(true);
          return;
        }

        SetCommentData(detail.comments);
        SetThankData(detail.thanks);
        detail.isbookmark?.status == 1 && SetBookMark(true);
        detail.isthankyou?.status == 1 && SetThankYou(true);
      })
      .catch(() => {
        setDetailLoadError(true);
      })
      .finally(() => {
        setIsDetailLoading(false);
      });
  }, [LoungeId]);

  useEffect(() => {
    let emojiData: any = null;
    dispatch(fetchStickerLounges({ emojiData }));
  }, [user_id]);

  function converDate(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    return formattedDate;
  }

  function getWords(str: any) {
    const result = str?.split(".").slice(0, 1).join(" ");
    return result;
  }

  const onSubmit = (data: any) => {
    if (data.chat_reply_msg != undefined) {
      if (data.chat_reply_msg == "") return;
      dispatch<any>(postLoungeCommentEditWdw(data)).then((res: any) => {
        reset();
        window.location.reload();
      });
    } else {
      dispatch<any>(postLoungeFlagWdw(data)).then((res: any) => {
        const message = res?.payload?.data?.[0]?.error;
        if (message) window.alert(message);
      });
    }
  };

  const onSubmit1 = (data: any) =>
    onSubmitWdw(
      data,
      LoungeId as string,
      dispatch,
      reset,
      navigate,
      SetCommentData
    );

  function converTime(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
    return formattedDate;
  }

  return (
    <>
      <div className="mid-main">
        <div className="container">
          <div className="mid-sec">
            <div className="banner-img">
              <Link to={`/disneyworld/lounge`}>
                <img
                  src={midBanner} loading="lazy"
                  className="img-fluid"
                  alt="mid-banner-img"
                />
              </Link>
            </div>
            <div className="land-detail">
              {detailLoadError ? (
                <div className="content__error-info">
                  <h2>Error</h2>
                  <p>Please try to open the page later.</p>
                </div>
              ) : (
                <div className="mid-card-sec mobile-card-sec">
                  {isDetailLoading
                    ? [...new Array(9)].map((_, index) => (
                        <Placeholder key={index} />
                      ))
                    : itemDetail?.map((obj) => (
                        <div
                          className="card-m rounded card-m2"
                          key={obj.chat_id}
                        >
                          <div className="card-s-img justify-content-between d-flex">
                            <div className="small-box d-flex">
                              <div className="small-c">
                                <a>
                                  <img
                                    src={getMouseWaitUserAvatarUrl(
                                      obj.user,
                                      GET_BASE_URL_IMAGE +
                                        "/disneyland/images/thumbs/" +
                                        obj.user.image +
                                        dTime
                                    )}
                                    className="img-fluid"
                                    alt={obj.user.user_name}
                                  />
                                </a>
                              </div>
                              <div className="small-tt">
                                <h6>
                                  {" "}
                                  <Link
                                    to={`/disneyworld/user/${obj.user?.user_id}/mypost`}
                                  >
                                    {obj.user?.user_name}
                                  </Link>
                                </h6>
                                <span>
                                  {obj.user.position} #{obj.user.totalpoints}{" "}
                                  Quality #{obj.user.rank}
                                </span>
                                <WdwLoungeName
                                  Time={obj.chat_time}
                                  Roomid={obj?.chat_room_id}
                                />
                              </div>
                            </div>

                            <>
                              <Helmet>
                                <title property="og:title">
                                  {getWords(obj.chat_msg)} - Disneyworld Lounge
                                </title>
                                <meta
                                  property="og:description"
                                  content={obj.chat_msg}
                                  name="description"
                                />
                                <meta
                                  name="keywords"
                                  content={getWords(obj.chat_msg)}
                                />
                                <meta
                                  property="fb:app_id"
                                  content="152066798153435"
                                />
                                <meta property="og:type" content="website" />
                                <meta
                                  property="og:site_name"
                                  content="MouseWait"
                                />
                                <meta
                                  property="og:image"
                                  content={
                                    GET_BASE_URL_IMAGE +
                                    "/disneyworld/chat_images_medium/" +
                                    obj.chat_img
                                  }
                                />
                                <meta
                                  property="og:url"
                                  content={
                                    GET_BASE_URL_IMAGE +
                                    `/disneyland/lands-talk/${obj.chat_id}/${obj.chat_msg}`
                                  }
                                />
                              </Helmet>
                            </>

                            <div>
                              <ToggleMenu
                                onSubmit={onSubmit}
                                register={register}
                                handleSubmit={handleSubmit}
                                setValue={setValue}
                                isLoading={""}
                                LoungeId={obj.chat_id}
                                username={obj.user.user_name}
                                userid={obj.user.user_id}
                                getThankYou={
                                  obj.isthankyou?.status == "1" ? true : false
                                }
                                getBookMark={
                                  obj.isbookmark?.status == "1" ? true : false
                                }
                                editType={
                                  obj.user?.user_id == user ? true : false
                                }
                                chat_reply_msg={obj.chat_msg}
                                // chat_type={obj.chat_type}
                                pageName={"Detail"}
                                lock={obj.islock == "0" ? "Lock" : "UnLock"}
                                chatRoomId={obj.chat_room_id}
                                getStick={
                                  obj.checksticky == null ? "Stick" : "UnStick"
                                }
                                getSubscribe={
                                  obj.subscribepost?.user_id == user &&
                                  obj.subscribepost != null
                                    ? false
                                    : true
                                }
                              />
                            </div>
                          </div>
                          <div className="card-body mw-detail-post-message">
                            <CommonPostMessage myChat={obj.chat_msg} />
                          </div>

                          <div className="card-img-b my-2 mw-detail-post-image">
                            {obj.chat_img?.includes("c_img") && (
                              <div>
                                <div className="mobileview-detail-img">
                                  <TransformWrapper>
                                    <TransformComponent>
                                      <ChatImageWithFallback
                                        filename={obj.chat_img}
                                        resort="disneyworld"
                                        className="card-img-top img-fluid"
                                        alt="img"
                                      />
                                    </TransformComponent>
                                  </TransformWrapper>
                                </div>
                                <ChatImageWithFallback
                                  filename={obj.chat_img}
                                  resort="disneyworld"
                                  className="card-img-top img-fluid  webView-detail-img"
                                  alt="img"
                                />
                              </div>
                            )}
                          </div>

                          <div className="card-body mw-detail-comments">
                            {commentData.map((cmt: any, index: any) => (
                              <div key={cmt?.chat_reply_id ?? cmt?.id ?? index}>
                                <CommentList
                                  cmt={cmt}
                                  /*      chatId={obj.chat_id} */ /* isko uncommnet karna h  */
                                  chatId={""}
                                  replyShow={false}
                                  stickerData={stickerItems}
                                />
                              </div>
                            ))}
                          </div>

                          <div className="card-body mw-detail-thanks">
                            <div className="thank-sec">
                              <div className="thank-t d-flex">
                                {thankData.length > 0 && (
                                  <>
                                    <h6>Thanked by:</h6>
                                    <ThankAvatarStrip
                                      thanks={thankData}
                                      resort="disneyworld"
                                      maxVisible={8}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="search-comm-sec des-main-sec fixed-bottom-bar">
          <div></div>
          <div>
            <div className="commentOutside">
              <CommentBox
                chatId={LoungeId}
                onSubmit={onSubmit1}
                register={register}
                handleSubmit={handleSubmit}
                stickerData={stickerItems}
                setValue={setValue}
              />
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default WDWLandLoungeDetail;
